import { FileIcon } from "@phosphor-icons/react/File";
import ProgressSpinner from "@/Shared/Icons/ProgressSpinner";
import { ProgressSpinnerSizes } from "@/Shared/Icons/ProgressSpinnerSizes";

interface ThumbnailProps {
  handleThumbnailClick: () => void;
  loading: boolean;
  error: string | undefined;
  thumbnailUrl: string | undefined;
  type?: "pdf" | "img" | undefined;
  showThumbnail: boolean;
}

export function ShipmentThumbnail(props: ThumbnailProps) {
  const { type = "pdf" } = props;

  if (props.loading) {
    return (
      <div style={{ fontSize: "12px", color: "var(--color-content-muted)" }}>
        <ProgressSpinner size={ProgressSpinnerSizes.Small} />
      </div>
    );
  }

  if (
    !props.showThumbnail ||
    !props.thumbnailUrl ||
    props.thumbnailUrl === "no-image" ||
    props.error
  ) {
    return (
      <div
        style={{
          height: 100,
          width: 70,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <FileIcon
          className="h-16 w-16"
          weight="fill"
          style={{ color: "var(--color-light-gray)" }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        width: type === "pdf" ? "70px" : "80px",
        height: type === "pdf" ? "100px" : "80px",
        position: "relative",
        overflow: "hidden",
        border: "1px solid var(--color-border)",
      }}
    >
      {/* A real button, so focus, Enter/Space and the accessible role all come
          from the browser rather than being hand-rolled onto the image. */}
      <button
        type="button"
        onClick={props.handleThumbnailClick}
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          padding: 0,
          border: 0,
          background: "none",
          cursor: "pointer",
        }}
      >
        <img
          src={props.thumbnailUrl}
          data-testid="thumbnail-image"
          style={{
            width: "100%",
            height: "100%",
          }}
          alt="thumbnail"
        />
      </button>
    </div>
  );
}
